export const COLORS = ['red', 'amber', 'green'];
export const DEFAULT_DURATIONS = { red: 30, amber: 3, green: 25 };
const minutes = (time) => Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));

// Days follow zone arming: Monday = 0, Sunday = 6. Overnight intervals belong to their starting day.
export function intervalActive(row, date) {
    const day = (date.getDay() + 6) % 7;
    const current = date.getHours() * 60 + date.getMinutes() + date.getSeconds() / 60;
    const start = minutes(row.start);
    const stop = row.stop === '23:59' ? 1440 : minutes(row.stop);
    if (row.start === row.stop) return row.days.includes(day);
    if (stop > start) return row.days.includes(day) && current >= start && current < stop;
    return (row.days.includes(day) && current >= start) || (row.days.includes((day + 6) % 7) && current < stop);
}

export function activeProfile(schedule, date) {
    return (schedule?.normal || []).some((row) => intervalActive(row, date)) ? 'normal' : 'night';
}

export function lightState(relays, profile, date) {
    if (profile === 'off') return { color: 'off', remaining: null };
    if (profile === 'night') return { color: date.getMilliseconds() < 500 ? 'amber' : 'off', remaining: null };
    return cycleState(relays, date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds() + date.getMilliseconds() / 1000);
}

export function cycleState(relays, elapsedSeconds) {
    const timings = Object.fromEntries(COLORS.map((color) => [color, Number(relays.find((relay) => relay.action === color)?.timeout) || DEFAULT_DURATIONS[color]]));
    const sequence = ['red', 'amber', 'green', 'amber'];
    const total = sequence.reduce((sum, color) => sum + timings[color], 0);
    let elapsed = Math.max(0, elapsedSeconds) % total;
    for (const color of sequence) {
        if (elapsed < timings[color]) return { color, remaining: Math.ceil(timings[color] - elapsed) };
        elapsed -= timings[color];
    }
    return { color: 'red', remaining: timings.red };
}
